import Divider from './Divider';
import { IDivider } from './Divider.interfaces';

export default Divider;
export { Divider, IDivider };
